var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imAccount)?_c('div',[_c('zjkj-im',{directives:[{name:"show",rawName:"v-show",value:(_vm.showImChat),expression:"showImChat"}],key:_vm.random,ref:"zjkjImRef",attrs:{"imAccount":_vm.imAccount,"imToken":_vm.imToken},on:{"close":_vm.closeIm}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }